import { FC } from 'react';

import { styled } from '../theme';
import { Size } from '../utility/common-props-helpers';
import SvgIcon from './SvgIcon';

export type CloseButtonProps = {
    onClick?: () => void;
    alt?: string;
    className?: string;
    size?: Size;
};

const StyledCloseButton = styled(SvgIcon)`
    z-index: 2;
    position: absolute;
    cursor: pointer;
    opacity: 0.2;
    transition: opacity 0.2s ease;
    :hover {
        opacity: 0.5;
    }
`;

const CloseButton: FC<CloseButtonProps> = ({
    onClick,
    alt = 'close',
    className,
    size = 'md',
    ...props
}) => {
    return (
        <StyledCloseButton
            src="/icons/ic-cross.svg"
            alt={alt}
            size={size}
            onClick={onClick}
            className={className}
            {...props}
        />
    );
};

export default CloseButton;
